import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'multiple-answer',
})

export default class MultipleAnswer extends Vue {


    // ------------------------------------------------------------
    // Properties

    @Prop()
    private content: any;

    @Prop({default: false})
    private showCorrect!: boolean;


    private get userAnswer() {
        const content = this.content;
        const userAnswer = content.userAnswer;
        return userAnswer;
    }

    private get question() {
        const question = this.content.resource;
        return question;
    }

    private get baseQuestions() {
        return this.question.answers;
    }
    // --------------------------------------------------------------
    // Hooks

    // -------------------------------------------------------------
    // Methods

    private validateAnswers(answer: any, index: number, isTrue = false) {
        const userAnswer = this.userAnswer;
        const selectedAnswer = userAnswer[index] ? userAnswer[index] : null;
        let activeItem = selectedAnswer.selection === isTrue  ? selectedAnswer.id : null;
        if (this.showCorrect) {
            activeItem = answer.isCorrect === isTrue ? answer.id : null;
        }
        return activeItem;
    }

    private genarateName(index: number) {
        const question = this.question;
        return `${question.id}-${index}-${this.showCorrect ? 'correct' : 'user'}`;
    }

    private genarateClassName(answer: any) {
        const userAnswer = this.userAnswer.find((item: any) => item.id === answer.id);
        const selectedAnswer = userAnswer && userAnswer.selection === answer.isCorrect;
        return selectedAnswer ? 'correct' : 'incorrect';
    }

}
